import { withInstall } from '@element-plus/utils'

import Text from './src/text.vue'

export const ElText = withInstall(Text)
export default ElText

export * from './src/text'
